export const firebaseConfig = {
  apiKey: "AIzaSyAzI4fm1qOcRgnh8-NFxR79_Km5pGYwYoM",
  authDomain: "ra9ra9-stg.firebaseapp.com",
  projectId: "ra9ra9-stg",
  storageBucket: "ra9ra9-stg.appspot.com",
  messagingSenderId: "970071400904",
  appId: "1:970071400904:web:3321e18ea90536bcdaa0fd",
}
